import { Tab } from 'react-bootstrap';

const Schedule = () => {
  return (
    <Tab.Pane className="my-3" eventKey="crawlerSchedule">
      <div dir="rtl" className="text-muted text-center py-5">
        زمان‌بندی خزش به‌زودی در دسترس خواهد بود.
      </div>
    </Tab.Pane>
  );
};

export default Schedule;
